import React from 'react';
export var SVGNotice = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { viewBox: "0 0 24 24", className: className },
        React.createElement("path", { d: "M2 2C2 0.895431 2.89543 0 4 0H20C21.1046 0 22 0.89543 22 2V22C22 23.1046 21.1046 24 20 24H4C2.89543 24 2 23.1046 2 22V2ZM20 2L4 2V22H20V2ZM6.5 5.5H17.5V8H6.5V5.5ZM13.5 11.5H6.5V14H13.5V11.5Z" })));
};
//# sourceMappingURL=SVGNotice.js.map